import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var ResultsText = function (_a) {
    var children = _a.children, id = _a.id, className = _a.className, style = _a.style;
    return (React.createElement("div", { id: id, className: cn(styles.root, className), style: style }, children));
};
export default ResultsText;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/resultsText/index.tsx
// module id = 1HbD
// module chunks = 2